
// frontend\src\config.js
const API_BASE_URL_FASTAPI = process.env.NODE_ENV === 'production' 
          ? 'https://connect-ai.ai' 
          : 'http://localhost:8000';

const isProduction = process.env.NODE_ENV === 'production';
const API_BASE_URL = isProduction ? 'https://connect-ai.ai' : 'http://localhost:8000';
const WIDGET_URL = isProduction ? 'https://connect-ai.ai' : 'http://localhost:2030';
//روابط الصور من على السيرفر مباشرة
const BACKEND_SITE_URL = process.env.NODE_ENV === 'production'
  ? 'https://connect-ai.ai'
  : 'http://localhost:8000';


const SITE_URL = process.env.NODE_ENV === 'production'
  ? process.env.REACT_APP_SITE_URL || 'https://connect-ai.ai'
  : 'localhost:2030';

const OFFER_URL_PATTERN = (clientName, uniqueLink) => 
  process.env.NODE_ENV === 'production'
    ? `https://connect-ai.ai/offers/${clientName}/${uniqueLink}`
    : `http://localhost:2030/offers/${clientName}/${uniqueLink}`;
 
// config.js
const WS_URL = process.env.NODE_ENV === 'production' 
  ? 'wss://connect-ai.ai/api/v1'  // ✅ بدون /ws
  : 'ws://localhost:8000/api/v1';  // ✅ بدون /ws

const config = {
  API_BASE_URL_FASTAPI,
  API_BASE_URL,
  BACKEND_SITE_URL,
  SITE_URL,
  WS_URL,
  WIDGET_URL,
  OFFER_URL_PATTERN
};

export default config;
